export const MOBILE_EXTRA_SMALL_WIDTH = '320px';
export const MOBILE_SMALL_WIDTH = '375px';
export const MOBILE_MEDIUM_WIDTH = '425px';
export const MOBILE_WIDTH = '600px';
export const MOBILE_HEIGHT = '700px';
export const TABLET_WIDTH = '768px';
export const DESKTOP_EXTRA_SMALL_WIDTH = '900px';
export const DESKTOP_SMALL_WITDH = '1024px';
export const DESKTOP_WIDTH = '1200px';

export const HEADER_HEIGHT = '55px';

export const DESKTOP_SMALL_WITDH_NUMBER = 1024;
